import React, { useEffect } from "react";

import useLayoutStore from "store/useLayoutStore";
import { Error500 } from "container/Error/Error500";
const Error500page = () => {
  const { setLayout } = useLayoutStore();

  useEffect(() => {
    setLayout({ isHeader: false, isSubTab: false });
  }, []);
  return (
    <>
      <Error500 />
    </>
  );
};

export default Error500page;
